import { render, staticRenderFns } from "./CheckoutAccordionContainerV2.vue?vue&type=template&id=ed63d890&"
import script from "./CheckoutAccordionContainerV2.vue?vue&type=script&lang=js&"
export * from "./CheckoutAccordionContainerV2.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutAccordionContainerV2.vue?vue&type=style&index=0&id=ed63d890&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports